import React from 'react';

import QuizQuestion from '../../QuizContainer/QuizQuestion/QuizQuestion';
import QuizContainer from "../../QuizContainer/QuizContainer";
import './Block.css';

const QuizBlock = props => {
	const selectedTopic = ['reading', 'vocabulary', 'grammar', 'comprehension'].filter((el, i) => i === props.selectedTopic-1)
	const optionsColor = ["rgb(245, 140, 140)", "rgb(255, 200, 113)", "rgb(224, 156, 255)", "rgb(163, 216, 255)"];
	const selectedColor = optionsColor[props.selectedTopic-1];
	if (props.selectedTopic === 1 || props.selectedTopic === 4) {   // reading and comprehension
		return (
			<div className={`quiz-block-app-3 ${selectedTopic}`} style={{ backgroundColor: selectedColor }}>
				<QuizContainer
					difficultyLevel={props.difficultyLevel}
					selectedTopic={props.selectedTopic}
					block={props.block}
					quizMode={false}
					closeQuiz={() => props.closeQuiz()}
					blockAnswered={val => props.blockAnswered(val) }
				/>
			</div>
		)
	} else {    // vocabulary and grammar
		return (
			<div className={`quiz-block-app-3 ${selectedTopic}`} style={{ backgroundColor: selectedColor }}>
				<QuizQuestion
					quizMode={false}
					showScript={true}
					block={props.block}
					optionsColor={selectedColor}
					closeQuiz={() => props.closeQuiz()}
					blockAnswered={val => props.blockAnswered(val) }
				/>
			</div>
		)
	}
};

export default QuizBlock;